"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockToppings = void 0;
var mockToppings = [{
  toppingName: 'Jalapeño Peppers',
  toppingCode: 'TOP-JPEP',
  toppingImage: '2f2fa82a-9a3d-4c56-adaf-d5d61e1a606d',
  index: 15,
  Left: 0,
  Right: 0
}, {
  toppingName: 'Mushrooms',
  toppingCode: 'TOP-MUS',
  toppingImage: '9f5377cb-cffd-4600-9442-992fbf509aa9',
  index: 8,
  Left: 0,
  Right: 0
}];
exports.mockToppings = mockToppings;